/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.rpc.SearchChirpService
 */
import * as References from './SearchChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.rpc.SearchChirpService#search
 */
export const SEARCH_QUERY_FIELD_NAME = 'com_hubspot_learning_center_search_rpc_SearchChirpService_search';
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_QUERY_FIELD_NAME,
  args: ['scoringConfig', 'pageLength', 'search', 'include', 'includeV2', 'categories', 'hubSpotSoftware', 'levels', 'businessObjectives', 'useCases', 'durations', 'languages', 'contentTypes', 'professorIds', 'visibilityGroup', 'hasAwardsOnly', 'partnersOnly', 'shouldFilterDeprecated', 'featuredHomepageOnly', 'featuredCertificationsOnly', 'sortingType', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.searchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.rpc.SearchChirpService#searchEvaluation
 */
export const SEARCH_EVALUATION_QUERY_FIELD_NAME = 'com_hubspot_learning_center_search_rpc_SearchChirpService_searchEvaluation';
export const SEARCH_EVALUATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_EVALUATION_QUERY_FIELD_NAME,
  args: ['scoringConfig', 'search', 'include', 'includeV2', 'categories', 'hubSpotSoftware', 'levels', 'businessObjectives', 'useCases', 'durations', 'languages', 'contentTypes', 'professorIds', 'visibilityGroup', 'hasAwardsOnly', 'partnersOnly', 'shouldFilterDeprecated', 'featuredHomepageOnly', 'featuredCertificationsOnly', 'sortingType', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.searchEvaluationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.search.rpc.SearchChirpService#sendFeedback
 */
export const SEND_FEEDBACK_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_search_rpc_SearchChirpService_sendFeedback';
export const SEND_FEEDBACK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SEND_FEEDBACK_MUTATION_FIELD_NAME,
  args: ['correlationId', 'resultMLOptionId', 'contentContainerType'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.sendFeedbackRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});